var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customization)?_c('lite-component',{attrs:{"material":_vm.customization.material,"customization":_vm.customization,"settings":_vm.$settings}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }